var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "29_\u9500\u552E\u5458\u65E5\u7ED3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54,36.07H48v-2a2,2,0,0,0-4,0v2H36v-2a2,2,0,1,0-4,0v2H26a2,2,0,0,0-2,2v18H12V40.16h0c.25-.1.51-.21.78-.34l22-9a2.53,2.53,0,0,0,.23-.12,13.54,13.54,0,1,0-8.44-.85L11.24,36.13l-.1,0c-.22.11-.43.19-.62.27-.82.33-2.52,1-2.52,3V56.63c0,1.93,1.76,3.44,4,3.44H54a2,2,0,0,0,2-2v-20A2,2,0,0,0,54,36.07ZM22.52,17.52A9.53,9.53,0,1,1,32,27.05,9.53,9.53,0,0,1,22.52,17.52ZM28,40.07H52v16H28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.74,44.37a2,2,0,0,0-2.83,0L38.29,49l-1.4-1.41a2,2,0,0,0-2.83,2.83l2.73,2.73.08.1a2,2,0,0,0,1.41.58h0a2,2,0,0,0,1.42-.58l.08-.1,5.94-5.94A2,2,0,0,0,45.74,44.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.48a7ed2f.svg";
export { ForwardRef as ReactComponent };